const CONTACTS = { email: "questanizer@gmail.com" };

export { CONTACTS };
